<script setup lang="ts">
import { computed } from 'vue'
import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'
import ImageShowcase from '@/components/ImageShowcase/index.vue'
import useProject from '@/composables/useProject'
import type { SearchResultProjectCardComponentModule } from '@/components/BrandedV2/SearchResultProjectCard/types'

const emit = defineEmits(['click'])
const props = defineProps<SearchResultProjectCardComponentModule.Props>()
const { n, t } = useI18n()

const { amenitiesList, priceRange, deliveryTermLabel, galleryPictures } = useProject(props.project)

const amenities = computed(() => amenitiesList.value.join(' | '))
const pictures = computed(() => {
  return galleryPictures.value.map(({ src, alt }) => {
    return {
      alt,
      src: `${src}&width=400`
    }
  }).slice(0, 5)
})

</script>
<script lang="ts">
export default {
  name: 'SearchResultProjectCard'
}

</script>

<template>
  <div
    class="w-[320px] relative overflow-hidden rounded-xl shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)]"
    :data-lh-id="dataLhId"
    @click="emit('click', project)">
    <ImageShowcase
      class="w-full bg-cover h-[212px]"
      lazy-load
      :data-lh-id="dataLhId"
      :images="pictures" />

    <div class="w-full flex flex-row justify-between top-0 absolute p-lh-16 pointer-events-none">
      <RoomieTag
        id="search-result-map-project-card"
        variant="information"
        :label="deliveryTermLabel"
        size="lg" />
    </div>

    <div class="p-lh-16 pointer-events-none">
      <h3 class="body-1-sb text-pine-600 mb-lh-8">
        {{ project.name }}
      </h3>

      <p class="body-2-m text-pine-500 mb-lh-8">
        <span>{{ amenities }}</span>
      </p>

      <p class="body-1-sb text-pine-600">
        {{ t('project.price.exact', { value: `${n(priceRange.min, 'currency')} ${project.currency}` }) }}
      </p>
    </div>
  </div>
</template>
